module.exports = __webpack_public_path__ + "static/media/chokha8.5208d3f4.webp";